"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLogLevelName = void 0;
const isLogLevelName = (val) => {
    if (['trace', 'debug', 'info', 'warn', 'error'].includes(val)) {
        return true;
    }
    return false;
};
exports.isLogLevelName = isLogLevelName;
//# sourceMappingURL=convertStringToLogLevelName.js.map